import { useEffect, useMemo, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { apiFetch } from "../../lib/http";
import { AppHeadingSlot } from "./AppHeading";

function NavItem({ to, iconClass, label }: { to: string; iconClass: string; label: string }) {
  const loc = useLocation();
  const isActive = loc.pathname === to || loc.pathname.startsWith(`${to}/`);
  return (
    <li className="nav-item">
      <Link className={`nav-link ${isActive ? "active" : ""}`} to={to}>
        <i className={`nav-icon ${iconClass}`} />
        <p>{label}</p>
      </Link>
    </li>
  );
}

export function AppLayout() {
  const [me, setMe] = useState<{ first_name: string; email: string } | null>(null);

  const initial = useMemo(() => {
    const ch = (me?.first_name || "").trim().slice(0, 1).toUpperCase();
    return ch || "?";
  }, [me]);

  useEffect(() => {
    (async () => {
      const resp = await apiFetch("/api/auth/me/", { method: "GET" });
      if (!resp.ok) return;
      const data = await resp.json().catch(() => null);
      if (data && typeof data.first_name === "string" && typeof data.email === "string") {
        setMe({ first_name: data.first_name, email: data.email });
      }
    })();
  }, []);

  async function signOut() {
    await apiFetch("/api/auth/logout/", { method: "POST" });
    window.location.href = "/";
  }

  return (
    <div className="app-wrapper">
      <nav className="app-header navbar navbar-expand bg-body">
        <div className="container-fluid">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" data-lte-toggle="sidebar" href="#" role="button">
                <i className="bi bi-list" />
              </a>
            </li>
          </ul>

          <AppHeadingSlot />

          <ul className="navbar-nav ms-auto align-items-center">
            <li className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle d-flex align-items-center"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div
                  className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-2"
                  style={{ width: 32, height: 32, fontSize: "0.9rem" }}
                >
                  {initial}
                </div>
              </a>

              <ul className="dropdown-menu dropdown-menu-end shadow-sm mt-2">
                <li className="px-3 py-2">
                  <div className="fw-semibold">{me?.first_name || "—"}</div>
                  <div className="text-muted small">{me?.email || ""}</div>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <div className="px-3">
                    <button type="button" className="btn btn-outline-danger w-100 btn-sm" onClick={() => void signOut()}>
                      <i className="bi bi-box-arrow-right me-2" />
                      Sign out
                    </button>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>

      <aside className="app-sidebar bg-body-secondary shadow" data-bs-theme="dark">
        <div className="sidebar-brand">
          <Link to="/" className="brand-link">
            <span className="brand-text fw-light d-flex align-items-center gap-2">
              <img src="/static/img/site-logo.png" alt="" className="sidebar-lute-icon" width="24" height="20" />
              <span>Human Jukebox</span>
            </span>
          </Link>
        </div>

        <div className="sidebar-wrapper">
          <nav className="mt-2">
            <ul className="nav sidebar-menu flex-column" role="navigation" aria-label="Main navigation" data-accordion="false">
              <NavItem to="/event_pages" iconClass="fas fa-calendar-days" label="Events" />
              <NavItem to="/song_requests" iconClass="fas fa-music" label="Requests" />
              <NavItem to="/tips" iconClass="fas fa-dollar-sign" label="Tips" />
            </ul>
          </nav>
        </div>
      </aside>

      <main className="app-main">
        <div className="app-content p-3">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

